import React, { Component } from 'react';
import './GroupsManagerDashboard.css';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import { Parser as JSON2CSVParser } from 'json2csv';
import SubHeader from '../GroupsManagerDashboard/SubHeader';
import ClientsWithGroups from '../GroupsManagerDashboard/ClientsWithGroups';
import { odometerHelper } from '../../../helpers';

import './GroupsManagerDashboard.css';

@inject('carsStore', 'groupsStore', 'commonStore', 'translationsStore', 'filterStore')
@observer
export default class GroupsManagerDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    const { groupsStore, carsStore, commonStore } = this.props;
    commonStore.setLoading(true);
    setTimeout(() => {
      Promise.all([groupsStore.load(), carsStore.loadMinimal(), carsStore.loadGroupsCount()]).then(() => {
        commonStore.setLoading(false);
      });
    }, 200);
  }

  componentDidMount = () => {};

  componentWillUnmount = () => {
    this.props.filterStore.reset();
  };

  onExport = () => {
    const { carsStore, translationsStore, groupsStore } = this.props;
    const { filtered } = carsStore;
    if (filtered.length > 0) {
      const fields = [
        {
          label: translationsStore.translate('groupsManager.vehicleTable.headerLabels.make'),
          value: row => row.make.descrizione
        },
        {
          label: translationsStore.translate('groupsManager.vehicleTable.headerLabels.model'),
          value: row => row.model.descrizione
        },
        {
          label: translationsStore.translate('groupsManager.vehicleTable.headerLabels.driver'),
          value: row => (row.driver && row.driver !== null ? row.driver.name : '-')
        },
        {
          label: translationsStore.translate('groupsManager.vehicleTable.headerLabels.group'),
          value: row => (row.groupId !== null ? (groupsStore.groups.find((group) => group.id === row.groupId) || { name: '-' }).name : '-')
        },
        {
          label: translationsStore.translate('groupsManager.vehicleTable.headerLabels.plate'),
          value: row => row.plate
        },
        {
          label: translationsStore.translate('groupsManager.vehicleTable.headerLabels.engineFuel'),
          value: row => translationsStore.translate(`alimentation.${row.alimentation}`)
        },
        {
          label: translationsStore.translate('groupsManager.vehicleTable.headerLabels.registrationDate'),
          value: row => moment(row.firstRegistrationDate).format('DD/MM/YYYY')
        },
        {
          label: translationsStore.translate('groupsManager.vehicleTable.headerLabels.odometer'),
          value: row => {
            let odometer;
            if (row.odometer && row.odometer.value) {
              odometer = Number(row.odometer.value).toFixed(0);
            } else if (row.gpsOdometer && row.gpsOdometer.value) {
              const { initialOdometer, gpsOdometer, gpsOdometerOnDisconnection } = row;
              odometer = Number(odometerHelper.computeOdometer({ initialOdometer, gpsOdometer, gpsOdometerOnDisconnection })).toFixed(0);
            }
            if (odometer === undefined && row.initialOdometer) {
              odometer = row.initialOdometer;
            }
            return odometer;
          }
        }
      ];

      const exportFilename = 'myfleet.csv';
      try {
        const parser = new JSON2CSVParser({ fields, delimiter: ';', withBOM: true });
        const csv = parser.parse(filtered);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');

        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', exportFilename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        console.error(err);
      }
    }
  };

  render() {
    const { groupsStore, carsStore } = this.props;
    return (
      <div className={`GroupsManagerDashboard ${this.props.commonStore.loading ? 'loading' : ''}`}>
        <SubHeader onExportClick={this.onExport} />
        {this.props.commonStore.loading === false && <ClientsWithGroups cars={carsStore.cars} carsFiltered={carsStore.cars} groups={groupsStore.groups} />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/GroupsManagerDashboard.js